import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmBatchRequestDialogComponent } from '../components/confirm-batch-request-dialog/confirm-batch-request-dialog.component';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { SaveConfirmDialogComponent } from '../components/save-confirm-dialog/save-confirm-dialog.component';
import { DirtinessService } from './dirtiness.service';


@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {
    constructor(
        private _dialog: MatDialog,
        private _dirtinessService: DirtinessService
    ){}
    confirmSave(): Promise<boolean> {
        const dialogRef = this._dialog.open(SaveConfirmDialogComponent, {
            width: '350px',
        });

        return dialogRef.afterClosed().toPromise();
    }

    confirm(title: string, message: string, no: string = "No", yes: string = "Yes"): Promise<boolean> {

        const dialogRef = this._dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: {
                title,
                message,
                no,
                yes
            }
        });

        return dialogRef.afterClosed().toPromise();
    }

    async confirmLeavingPage(title: string, message: string): Promise<boolean> {

        const leaving: boolean = await this.confirm(title, message);

        if(leaving) 
            this._dirtinessService.setDirty(false);

        return leaving;
    }


    confirmBatchRequest(title: string, message: string): Promise<
    {
        confirm: boolean,
        batch_number: string
    }> {

        const dialogRef = this._dialog.open(ConfirmBatchRequestDialogComponent, {
            width: '350px',
            data: {
                title,
                message
            }
        });

        return dialogRef.afterClosed().toPromise();
    }
}